module.exports = __webpack_public_path__ + "img/city-2.f3f7dd2d.jpeg";